/**
 * Reka UI's `pointerDownOutside` / `focusOutside` / `interactOutside` events wrap
 * the underlying DOM event in `detail.originalEvent`. Resolve the element that
 * actually triggered the interaction, falling back to the event's own target.
 */
export function getOutsideEventTarget(event: Event): EventTarget | null {
	const outsideEvent = event as Event & { detail?: { originalEvent?: Event } };

	return outsideEvent.detail?.originalEvent?.target ?? event.target;
}
